// extracted by mini-css-extract-plugin
module.exports = {"guideContainer":"_1D1m8","sanjiao":"_1tI9T","textContainer":"_3edEB","disappearContainer":"_2k9VE"};